
import React, { useState, useEffect } from "react";
import classes from "./Activity.module.css";
import { UniversalDateFormat } from "./Header";
import { useParams } from "react-router-dom";
import { getDossierDetails,linkVisitHistoryUpdate } from "../Dossier/Network_call";

const Activity = (props) => {
  const { implId, id } = useParams();
  const [err, setErr] = useState(false);
  const [dossierData, setDossierData] = useState(null);
  const [dossierNotFound, setDossierNotFound] = useState(false);
  let ActivityData = [];

  if (props.data.length !== 0) {
    ActivityData = [...props.data];
  }

  const fetchDossierData = async () => {
    try {
      const result = await getDossierDetails(implId, id);
      if (result.status === 200) {
        let data = result.data;
        console.log("res", data);
        if (data.error === "Dossier not found") {
          setDossierNotFound(true);
        } else {
          setDossierData(data);
        }
      } else {
        setErr(true);
      }
    } catch (error) {
      console.error("Error fetching dossier details: ", error);
      setErr(true);
    }
  };

  useEffect(() => {
    if (implId && id) {
      console.log("implleeeeee id", implId, id);
      fetchDossierData();
    }
  }, [implId, id]);

  const parseDateSafely = (dateValue) => {
    if (!dateValue) return null;

    // If already a Date
    if (dateValue instanceof Date) return dateValue;

    // ISO or timestamp → safe
    const isoDate = new Date(dateValue);
    if (!isNaN(isoDate.getTime())) return isoDate;

    // Handle DD-MM-YYYY or DD/MM/YYYY
    const parts = String(dateValue).split(/[-/]/);
    if (parts.length === 3) {
      const [dd, mm, yyyy] = parts;
      const parsed = new Date(`${yyyy}-${mm}-${dd}`);
      if (!isNaN(parsed.getTime())) return parsed;
    }

    return null;
  };

  const currentDate = new Date();

const upComming = ActivityData
  .filter((e) => parseDateSafely(e.date) > currentDate)
  .sort((a, b) => parseDateSafely(a.date) - parseDateSafely(b.date));

const upCommingFirstFive = upComming.slice(0, 5);

  const pastActivity = ActivityData
  .filter((item) => parseDateSafely(item.date) <= currentDate)
  .sort((a, b) => parseDateSafely(b.date) - parseDateSafely(a.date));

console.log("pastActivitys", pastActivity);

const LastFiveActivity = pastActivity.slice(0, 5);

console.log("LastFiveActivity", LastFiveActivity);
  const handleLinkClick = async (index) => {

    console.log("link idddd", index);

    const linkId = index;

    try {
     const response =  await linkVisitHistoryUpdate(linkId);

     console.log("Link Visiteddddd", response.data);

    } catch (error) {
      console.log(error);
    }
  };


  return (
    <>
      <div className={classes.activityMain}>
        <div className={classes.activitySection}>
          <div className={classes.activityContainer}>
            {upComming.length !== 0 && (
              <h3 className={classes.activityHead}>Upcoming Activity</h3>
            )}
            {upComming.length !== 0 && (
              <>
                {upCommingFirstFive.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "5em",
                    }}
                  >
                    <div>
                      <p>
                        {new Date(item.date).toLocaleDateString()}
                      </p>
                    </div>
                    <div>
                      <p>{item.status}</p>
                    </div>
                  </div>
                ))}
              </>
            )}
            {LastFiveActivity.length !== 0 && (
              <>
                <h3 className={classes.activityHead}>Recent Activity</h3>
                {LastFiveActivity.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "5em",
                    }}
                  >
                    <div>
                      <p>
                        {new Date(item.date).toLocaleDateString()}
                      </p>
                    </div>
                    <div>
                      <p>{item.status}</p>
                    </div>
                  </div>
                ))}
              </>
            )}
            {dossierData?.links && (
              <div className={classes.linkContainer}>
                <h3 className={classes.activityHead} > Dossier Link</h3>
                {dossierData.links.map((link) => (
                  <p key={link.id}>
                    <a style={{marginLeft:"6rem" ,color:"blue"}}
                      href={link.links}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => handleLinkClick(link.id)}
                    >
                      {link.name}
                    </a>
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Activity;
